export const SET_CHATBOTS_LIST = "SET_CHATBOTS_LIST";
export const SET_CHATBOT_NODES = "SET_CHATBOT_NODES";
export const SET_QUEUES_SELECT_OPTIONS = "SET_QUEUES_SELECT_OPTIONS";
export const SET_NODE_SELECTED = "SET_NODE_SELECTED";
export const SET_CHATBOT_NODES_LOADING = "SET_CHATBOT_NODES_LOADING";
